import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, CircularProgress, FormControl, FormControlLabel, MenuItem, Radio, RadioGroup, Select, Switch, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import Page from '../../component/Page'
import { getBranchList, getEmployeeDetail } from './services/settingApi'
import api from '../../api/api'
import { SETTING_CONFIG } from './config.'
import dayjs from 'dayjs'
import Swal from 'sweetalert2'
import { getData, postData, putData } from '../../services/api'
import RequireField from '../../component/RequireField'
import ResetPassword from './component/ResetPassword'

export default function ViewEmployee() {
    const { id } = useParams()
    const navigate = useNavigate();

    const [UserLogin, setUserLogin] = useState('')
    const [loading, setLoading] = useState(false)
    const [resetLoading, setResetLoading] = useState(false)
    const [openReset, setOpenReset] = useState(false)
    const [EmpNo, setEmpNo] = useState('')
    const [Fname, setFname] = useState('')
    const [Lname, setLname] = useState('')
    const [branchs, setBranchs] = useState([])
    const [BranchNo, setBranchsNo] = useState('')
    const [Roles, setRoles] = useState([])
    const [RolesId, setRolesId] = useState('')
    const [Position, setPosition] = useState('')
    const [Password, setPassword] = useState('')
    const [email, setEmail] = useState('')
    const [tel, setTel] = useState('')
    const [detail, setDetail] = useState()
    const [Status, setStatus] = useState('Y')
    const [Permissions, setPermissions] = useState([])
    const [action, setAction] = useState()
    const [UserLoginError, setUserLoginError] = useState(false)
    const [UserLoginErrorText, setUserLoginErrorText] = useState('')
    const [FnameError, setFnameError] = useState(false)
    const [LnameError, setLnameError] = useState(false)
    const [RoleError, setRoleError] = useState(false)
    const [PositionError, setPositionError] = useState(false)
    const [PasswordError, setPasswordError] = useState(false)
    const [emailError, setEmailError] = useState(false)
    const [telError, setTelError] = useState(false)


    const { profile } = useSelector(state => state.profile)

    const getEmployeeDetail = async () => {
        getData(SETTING_CONFIG.requests.getEmployee.url + '/', id).then((data) => {
            if (data.status === true) {
                setDetail(data.result)
                setFname(data.result.Fname)
                setLname(data.result.Lname)
                setEmail(data.result.Email)
                setPosition(data.result.Position)
                setTel(data.result.Tel)
                setEmpNo(data.result.EmpNo)
                setRolesId(data.result.RoleId.RoleId)
                setUserLogin(data.result.UserLogin)
                setBranchsNo(data.result.BranchNo.BranchNo)
                setStatus(data.result.Status)
                setPermissions(data.result.Permissions)
                setAction(data?.result?.Permissions[0])
            }
        })
    }
    const getPermissions = (e) => {
        getData('dbms/admin-roles/', e).then((data) => {
            if (data.status === true) {
                setPermissions(data.result?.Permissions)
                setAction(data?.result?.Permissions[0])
            }
        })
    }
    const getAdmin = () => {
        getData('dbms/admin-roles').then((data) => {
            if (data.status === true) {
                setRoles(data.result)
            }
        })
    }

    useEffect(() => {
        getBranchList(null, setBranchs)
        getAdmin()
        setBranchsNo(profile?.BranchNo?.BranchNo)
        if (id) {
            getEmployeeDetail()
        }
    }, [])


    const employeeAdd = async () => {
        setLoading(true)
        const body = {
            UserId: detail?.UserId || null,
            UserLogin: UserLogin,
            Fname: Fname,
            Lname: Lname,
            Position: Position,
            EmpNo: EmpNo,
            NationalityId: null,
            Email: email,
            Tel: tel,
            Password: Password,
            BranchNo: BranchNo,
            RoleId: RolesId,
            Permissions: Permissions,
            Status: Status
        }
        if (body?.UserId) {
            const url = SETTING_CONFIG.requests.getEmployee.url + `/${body?.UserLogin}`;
            putData(url, body).then((response) => {
                if (response.status === true) {
                    getEmployeeDetail()
                    setLoading(false)
                    Swal.fire(
                        'ทำรายการสำเร็จ',
                        '',
                        'success'
                    )
                } else {
                    setLoading(false)
                    Swal.fire({
                        title: response?.message || 'ทำรายการไม่สำเร็จ',
                        icon: 'warning',
                    })
                }
            })

        } else {
            postData(SETTING_CONFIG.requests.getEmployee.url, body).then((response) => {
                if (response.status === true) {
                    setLoading(false)
                    navigate('/setting/employee/' + response.result.UserLogin)
                    Swal.fire(
                        'ทำรายการสำเร็จ',
                        '',
                        'success'
                    )
                } else {
                    setLoading(false)
                    Swal.fire({
                        title: response?.message || 'ทำรายการไม่สำเร็จ',
                        icon: 'warning',
                    })
                }
            })
        }

    }
    const handleSubmit = () => {
        if (UserLogin.length === 0) {
            setUserLoginError(true)
            setUserLoginErrorText('กรุณากรอก User Login')
        }
        if (Fname.length === 0) {
            setFnameError(true)
        }
        if (Lname.length === 0) {
            setLnameError(true)
        }
        if (RolesId.length === 0) {
            setRoleError(true)
        }
        if (!id && Password.length === 0) {
            setPasswordError(true)
        }
        if (Position.length === 0) {
            setPositionError(true)
        }
        if (email.length === 0) {
            setEmailError(true)
        }
        if (tel.length === 0) {
            setTelError(true)
        }
        if (UserLoginError === false && UserLogin.length > 0 && Fname.length > 0 && Lname.length > 0 && Position.length > 0 && email.length > 0 && tel.length > 0) {
            employeeAdd()

        }
    }
    const postResetPassword = async () => {
        setResetLoading(true)
        const url = `employees/${UserLogin}/reset-password`;
        postData(url).then((response) => {
            if (response.status === true) {
                setResetLoading(false)
                setOpenReset(false)
                Swal.fire({
                    title: `ทำรายการสำเร็จ`,
                    icon: 'success',
                    // showCancelButton: true,
                    showDenyButton: true,
                    denyButtonColor: '#385898',
                    denyButtonText: 'คัดลอกลิงก์',
                    confirmButtonColor: '#4ab866',
                    confirmButtonText: 'ตกลง'
                    // cancelButtonColor: '#d33',
                }).then((result) => {
                    if (result.isConfirmed) {

                    }
                    if (result.isDenied) {
                        navigator.clipboard.writeText(response.result.Url).then(() => {
                            // Alert the user that the action took place.
                            // Nobody likes hidden stuff being done under the hood!
                            Swal.fire(
                                'คัดลอกเเล้ว',
                                `ผู้ใช้งานระบบ สามารถเข้าใช้งานและทำการตั้งรหัสผ่านใหม่ ได้ที่ 
                                 ${response.result.Url} `,
                                'success'
                            )
                        });
                    }
                })

                // Swal.fire(
                //     'ทำรายการสำเร็จ',
                //     `ผู้ใช้งานระบบ สามารถเข้าใช้งานและทำการตั้งรหัสผ่านใหม่ ได้ที่ 
                //      ${response.result.Url} `,
                //     'success'
                // )
            } else {
                setResetLoading(false)
                Swal.fire({
                    title: response?.message || 'ทำรายการไม่สำเร็จ',
                    icon: 'warning',
                })
            }
        })
    }
    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <form >
                    <div class="container-fluid" >

                        <div class=" d-flex row justify-content-between align-items-baseline">
                            <div class="col-lg-12 col-md-12 text-left ">
                                <label class="title-content mb-4">
                                    ข้อมูลผู้ใช้งาน
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-sm-12 ">
                                <label class="labelInput">รหัสพนักงาน</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField disabled={id ? true : false} value={EmpNo} onChange={e => setEmpNo(e.target.value)} variant="standard" fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                            </div>
                            <div class="col-lg-4 col-sm-12">
                                <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <FormControl disabled={id ? true : false} variant="standard" fullWidth >
                                        <Select value={BranchNo || ''} onChange={e => setBranchsNo(e.target.value)} disableUnderline >
                                            {branchs?.map((x) => (
                                                <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-lg-4 col-sm-12 ">
                                <label class="labelInput">ตำแหน่งงาน</label>
                                <RequireField value={Position} onChange={setPosition} type={'text'} error={PositionError} setError={setPositionError} textError={'กรุณากรอกตำแหน่งงาน'} />

                            </div>
                            <div class="col-lg-4 col-sm-6 ">
                                <label class="labelInput">กลุ่มผู้ใช้งาน</label>
                                <Box className={`backgroundField ${RoleError ? 'error' : ''}`}>
                                    <FormControl variant="standard" fullWidth >
                                        <Select value={RolesId || ''} onChange={e => {
                                            setRolesId(e.target.value)
                                            getPermissions(e.target.value)
                                        }} disableUnderline
                                            onBlur={e => {
                                                if (!e.target.value) {
                                                    setRoleError(true)
                                                } else {
                                                    setRoleError(false)
                                                }
                                            }}
                                            MenuProps={{
                                                style: {
                                                    maxHeight: 400,
                                                },
                                            }} >
                                            {Roles?.map((x) => (
                                                <MenuItem value={x?.RoleId}>{x?.RoleName}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                                {RoleError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณาเลือกสิทธิ์การใช้งานระบบ</span>}

                            </div>

                        </div>
                        <div class="row">

                            <div class="col-lg-4 col-sm-12 ">
                                <label class="labelInput">ชื่อ</label>
                                <RequireField value={Fname} onChange={setFname} type={'text'} error={FnameError} setError={setFnameError} textError={'กรุณากรอกชื่อ'} />

                            </div>
                            <div class="col-lg-4 col-sm-6">
                                <label class="labelInput">นามสกุล</label>
                                <RequireField value={Lname} onChange={setLname} type={'text'} error={LnameError} setError={setLnameError} textError={'กรุณากรอกนามสกุล'} />

                            </div>


                        </div>

                        <div class="row">

                            <div class="col-lg-4 col-sm-12 ">
                                <label class="labelInput">User Login</label>
                                <Box className={`backgroundField ${UserLoginError ? 'error' : ''}`}>
                                    <TextField disabled={id ? true : false} value={UserLogin} onChange={e => setUserLogin(e.target.value)} variant="standard" fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                        onBlur={e => {
                                            if (!e.target.value) {
                                                setUserLoginError(true)
                                                setUserLoginErrorText('กรุณากรอก User Login')
                                            } else {
                                                getData(SETTING_CONFIG.requests.getEmployee.url + '/', e.target.value).then((data) => {
                                                    if (data.result) {
                                                        setUserLoginError(true)
                                                        setUserLoginErrorText('กรุณากรอก User Login ใหม่')
                                                    } else {
                                                        setUserLoginError(false)

                                                    }
                                                })
                                            }
                                        }}
                                    />
                                </Box>
                                {UserLoginError && <span style={{ color: 'red', fontSize: '12px', }}>{UserLoginErrorText}</span>}

                            </div>
                            <div class="col-lg-4 col-sm-6">
                                {!id && <>
                                    <label class="labelInput">Password</label>
                                    <Box className={`backgroundField ${!id && PasswordError ? 'error' : ''}`}>
                                        <TextField type='password' value={Password} onChange={e => setPassword(e.target.value)} variant="standard" fullWidth
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                            onBlur={e => {
                                                if (!e.target.value) {
                                                    setPasswordError(true)
                                                } else {
                                                    setPasswordError(false)
                                                }
                                            }}
                                        />
                                    </Box>
                                </>}

                                {!id && PasswordError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกรหัสผ่าน</span>}


                            </div>


                        </div>



                        <div class="row">

                            <div class="col-lg-4 col-sm-6">
                                <label class="labelInput">อีเมล</label>

                                <RequireField value={email} onChange={setEmail} type={'text'} error={emailError} setError={setEmailError} textError={'กรุณากรอกอีเมล'} />

                            </div>
                            <div class="col-lg-4 col-sm-6">
                                <label class="labelInput">เบอร์โทรศัพท์</label>

                                <RequireField value={tel} onChange={setTel} type={'number'} error={telError} setError={setTelError} textError={'กรุณากรอกเบอร์โทรศัพท์'} />

                            </div>
                        </div>
                        {id &&
                            <div class="row" >
                                <div class="col-lg-4 col-md-6">
                                    <label class="labelInput me-3">ผู้สร้าง</label> <label class="message-error-label">( {dayjs(detail?.CreateDate).format('DD/MM/BBBB')} )</label>
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                        <TextField disabled={id ? true : false} value={detail?.CreateId} variant="standard" fullWidth
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                    </Box>
                                </div>
                                <div class="col-lg-4 col-md-6">
                                    <label class="labelInput me-3">ผู้แก้ไข</label> <label class="message-error-label">( {dayjs(detail?.ModifiedDate).format('DD/MM/BBBB')} )</label>
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                        <TextField disabled={id ? true : false} value={detail?.ModifiedId} variant="standard" fullWidth
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                    </Box>
                                </div>
                            </div>}
                        <div class="row" >
                            <div class="col-12 mt-1  text-left ">
                                <RadioGroup row value={Status} onChange={e => setStatus(e.target.value)}>
                                    <FormControlLabel value="Y" control={<Radio />} label="ใช้งาน" />
                                    <FormControlLabel value="N" control={<Radio />} label="ไม่ใช้งาน" />
                                </RadioGroup>
                            </div>
                        </div>
                        {RolesId && <>
                            <hr class="chr" />
                            <div class="row" >
                                <div class="col-sm-12 col-lg-4">
                                    <div class="border-row" >
                                        <div class=" d-flex justify-content-between">
                                            <div >
                                                <label class="title-content">เมนู</label>
                                            </div>

                                        </div>
                                        <div class="row mt-2" >
                                            <div class="Warehouse col-12">
                                                <div class="table-responsive-sm">
                                                    <table class="table table-borderless table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th class="text-center">ชื่อ</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Permissions?.map((x, i) => (
                                                                <tr class={`${x?.Subject === action.Subject ? 'active' : ''}`} onClick={() => setAction(x)}>
                                                                    <td>{x?.Subject}</td>
                                                                </tr>

                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-12 col-lg-8">
                                    <div class="border-row">
                                        <div class=" d-flex justify-content-between">
                                            <div >
                                                <label class="title-content">รายละเอียด {action?.Subject && `(${action?.Subject})`}</label>
                                            </div>

                                        </div>
                                        <div class="row mt-2">
                                            <div class="Warehouse col-12">
                                                <div class="table-responsive-sm">
                                                    <table class="table table-borderless table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: "80%" }}>ชื่อ</th>
                                                                <th style={{ width: "20%" }}>สถานะ</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {action?.Actions?.map((x, i) => (
                                                                <tr>
                                                                    <td >{x?.Name}</td>
                                                                    <td class="text-center">
                                                                        <Switch checked={x?.Permit}
                                                                            onChange={e => {
                                                                                const item = action?.Actions?.map((z, index) => {
                                                                                    z.Permit = i === index ? e.target.checked : z?.Permit
                                                                                    return z
                                                                                })
                                                                                const Permis = Permissions?.map((n, index) => {
                                                                                    n.Actions = n?.Subject === action?.Subject ? item : n?.Actions
                                                                                    return n
                                                                                })
                                                                                setAction({
                                                                                    Subject: action?.Subject,
                                                                                    Actions: item
                                                                                })
                                                                                setPermissions(Permis)
                                                                            }} />
                                                                    </td>

                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </>}

                        <hr class="chr" />
                        <div class="row ">

                            <div class="col-12 text-left">
                                <Button variant='outlined' onClick={() => navigate(-1)} startIcon={<FontAwesomeIcon icon={faArrowLeft} />} sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                                <Button variant='contained' disabled={loading} sx={{ width: '130px', fontSize: '14px' }} onClick={handleSubmit}>{loading ? <CircularProgress size={'24px'} color="inherit" /> : id ? 'เเก้ไข' : 'บันทึก'} </Button>
                                {id && <Button variant='contained' color='warning' sx={{ width: '130px', fontSize: '14px', marginLeft: '10px' }} onClick={() => setOpenReset(true)}>{'ตั้งรหัสผ่านใหม่'} </Button>}
                            </div>
                        </div>
                    </div>
                    <ResetPassword open={openReset} setOpen={setOpenReset} postResetPassword={postResetPassword} resetLoading={resetLoading} />
                </form>
            </Page>
        </div>
    )
}
